module.exports = __webpack_public_path__ + "img/petstairs45.31150b77.jpg";